<h1 translate>ERROR_PAGE_NOT_FOUND</h1>
<h2 translate>ERROR_PAGE_NOT_FOUND_TITLE</h2>
<p translate>ERROR_PAGE_NOT_FOUND_PARA</p>
<p>
  <a [routerLink]="['']" class="btn brand btn-outline" translate>ERROR_PAGE_RETURN_HOME</a>
</p>
